import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import PrimaryButton from '../components/shared/PrimaryButton';
import Nav from '../components/admin/NavAdmin';
import PrimaryButtonDark from '../components/shared/PrimaryButtonDark';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <><Nav /><div className="flex-col center-vh h-100vh g-30 px-40">
          <div className="text-center max-w-500">
              <h1 className="f-xxl fw-bold c-p mb-20">404</h1>
              <h2 className="f-xl fw-bold mb-10">Pagina niet gevonden</h2>
              <p className="mb-20 c-g">
                  Sorry, de pagina die je probeert te bezoeken bestaat niet of is verplaatst.
              </p>
              <div className="flex-row center-h mxw-400 g-15">
                  <PrimaryButtonDark className="d-f-c text-center" onClick={() => navigate(-1)}>
                      Ga terug
                  </PrimaryButtonDark>
                  <PrimaryButtonDark className="w-auto text-center" onClick={() => window.location.href = '/'}>
                      Ga naar homepagina
                  </PrimaryButtonDark>
              </div>
          </div>
          <div className="mt-30 f-s c-g">
              <p>Heb je hulp nodig? <Link to="mailto:info@brandvisionx.be" className="c-p td-n">Neem contact met ons op</Link></p>
          </div>
      </div></>
  );
};

export default NotFound; 